module.exports = __webpack_public_path__ + "static/2-f23f807676001d47d3583d9403175028.jpg";